import { Link, Outlet } from '@tanstack/react-router';
import { Footer } from '../components/Footer.tsx';
import { Nav } from '../components/Nav.tsx';

export function Layout() {
  return (
    <>
      <div className="grain" aria-hidden="true" />
      {/* The page dissolves before it reaches the nav rather than sliding
          visibly behind a translucent pill. */}
      <div className="veil" aria-hidden="true" />

      <Link className="skip" to="/" hash="problem">
        Skip to content
      </Link>

      <Nav />
      <Outlet />
      <Footer />
    </>
  );
}

export function NotFound() {
  return (
    <main className="sec miss">
      <h1 className="big">
        No such floor.
        <br />
        <span className="grad">Back to the plan.</span>
      </h1>
      <p className="sec__sub">
        That address does not exist on this site. There is the floor plan and there is the way to
        reach us, and nothing else.
      </p>
      <Link className="nav__cta miss__cta" to="/">
        Return to the floor<span>↗</span>
      </Link>
    </main>
  );
}
